// export function setToken(token) {
//     localStorage.setItem('access-token', token)
// }

// export function getToken() {
//     return localStorage.getItem('access-token')
// }

// export function clearToken() {
//     localStorage.removeItem('access-token')
// }

import Cookies from 'js-cookie'
import jwt from 'jsonwebtoken'

const BSRS_ACCESS_TOKEN = 'bsrs_access_token'
const ACCESS_TOKEN = 'access_token'
const EXPIRES_ON = 'expires_on'
const REFRESH_TOKEN = 'refresh_token'
const SERVICE_TOKEN = 'service_token'
const ROLE = 'isAdmin'
const API_URL = 'api_server_url'
const CLIENT_ID = 'client_id'
const SERVICE_TOKEN_EXPIRES = 'service_token_expires_on'
const USER_ID = 'userId'
const RESULT_PER_PAGE = 'result_per_page'
const IS_FIRST_CHANGE_PASSWORD = 'isFirstChangePassword'
const CURRENT_PAGE = 'currentPage'

export function getCookie(key) {
    return Cookies.get(key)
}

export function setCookie(key, value) {
    Cookies.set(key, value)
}

export function removeCookie(key) {
    Cookies.remove(key)
}

export function getAccessToken() {
    return getCookie(ACCESS_TOKEN)
}

export function getService() {
    return getCookie({ CLIENT_ID, API_URL })
}
export function getIsFirstChangePassword() {
    return getCookie(IS_FIRST_CHANGE_PASSWORD)
}

export function getResultPerPage() {
    const resultPerPage = parseInt(getCookie(RESULT_PER_PAGE), 10)
    return !isNaN(resultPerPage) ? resultPerPage : 10
}
export function getAllToken() {
    if (!getCookie(ACCESS_TOKEN)) return {}
    return {
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN),
        isFirstChangePassword: getCookie(IS_FIRST_CHANGE_PASSWORD)
    }
}

export function setToken({
    access_token,
    expires_on,
    refresh_token,
    result_per_page,
    isFirstChangePassword
}) {
    setCookie(ACCESS_TOKEN, access_token)
    setCookie(EXPIRES_ON, expires_on)
    setCookie(REFRESH_TOKEN, refresh_token)
    setCookie(RESULT_PER_PAGE, result_per_page)
    setCookie(IS_FIRST_CHANGE_PASSWORD, isFirstChangePassword)
}

export function clearToken() {
    removeCookie(ACCESS_TOKEN)
    removeCookie(ROLE)
    removeCookie(REFRESH_TOKEN)
    removeCookie(SERVICE_TOKEN)
    removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(RESULT_PER_PAGE)
    removeCookie(IS_FIRST_CHANGE_PASSWORD)
}

export function getServiceToken() {
    if (!getCookie(SERVICE_TOKEN)) return {}
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES)
    }
}

export function setServiceToken({
    token,
    expires_on,
    result_per_page
}) {
    if (typeof (token) !== undefined)
        setCookie(SERVICE_TOKEN, token)
    if (typeof (expires_on) !== undefined)
        setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
    setCookie(RESULT_PER_PAGE, result_per_page)
}

export function getUserInfo(access_token) {
    if (!access_token) return {}

    const {
        iat,
        exp,
        appid,
        name,
        unique_name: email
    } = jwt.decode(access_token)

    return {
        iat,
        exp,
        appid,
        name,
        email
    }
}

export function getBSRSToken() {
    let returnData = { bsrsToken: getCookie(BSRS_ACCESS_TOKEN), role: getCookie(ROLE), userId: getCookie(USER_ID) }
    return returnData
}

export function setBSRSToken({ token, role, userId, result_per_page, isFirstChangePassword }) {
    clearBSRSToken()
    setCookie(BSRS_ACCESS_TOKEN, token)
    setCookie(ROLE, role)
    setCookie(USER_ID, userId)
    setCookie(RESULT_PER_PAGE, result_per_page ? result_per_page : 10)
    setCookie(IS_FIRST_CHANGE_PASSWORD, isFirstChangePassword)
}

export function setCurrentPage(page) {
    setCookie(CURRENT_PAGE, page)
}
export function getCurrentPage() {
    return parseInt(getCookie(CURRENT_PAGE), 10)
}
export function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN)
    removeCookie(ACCESS_TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(REFRESH_TOKEN)
    removeCookie(SERVICE_TOKEN)
    removeCookie(ROLE)
    removeCookie(API_URL)
    removeCookie(CLIENT_ID)
    removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(USER_ID)
    removeCookie(RESULT_PER_PAGE)
    removeCookie(IS_FIRST_CHANGE_PASSWORD)
}


// WEBPACK FOOTER //
// ./src/lib/auth.js